export namespace WSImport {
    export type JobProgressStatus = 'loading'|'saving'|'success'|'error'|'update'|'canceled'

    export class JobProgressTasksFile {
        url:string
        authorization?:string
        set_in: {
            resource: string
            id: any
            prop: string
            value: string|Array<string>
            index?: number
            subprop?: string
        }
        
        status?: JobProgressStatus
        message?: string
    }

    export class JobProgressTasksItem {
        resource: string
        element: any
        status?: JobProgressStatus
        message?: string
    }

    export class JobProgressTasks {
        main: JobProgressTasksItem
        translations: Array<JobProgressTasksItem>
        files?: Array<JobProgressTasksFile>
    }

    export class JobProgress { 
        time_begin:number
        time_end:number
        element?:any
        status?:JobProgressStatus
        tasks?:JobProgressTasks
        message?:string
        secondary?:boolean
    }

    export class JobItem {
        resource:string
        id:string
        secondary?:boolean
        related?: Array<{ resource: string, id: string }>
    }

    export class JobBase {
        started = false;
        user:any = null;
        type:JobType = null;
        items:Array<JobItem> = [];
        progress:Array<JobProgress> = []

        constructor(public realm:string, public time:number, public force:'update'|'update-secondaries'|'insert') {
        }

        initialize() {
            for(let _item of this.items) {
                this.progress.push({ 
                    time_begin: null,
                    time_end: null,
                    secondary: _item.secondary
                })
            }
        }
    }

    export class JobEntouranceItem extends JobItem {
    }

    export class JobEntourance extends JobBase {
        type:'entourance' = 'entourance'

        constructor(public realm:string, public time:number, update:boolean, public APIUrl:string, public items:Array<JobEntouranceItem>) {
            super(realm, time, update ? 'update' : null)
        }
    }

    export class JobFileItem extends JobItem {
        type:'csv'|'xlsx'
        src:string
        data:any
    }

    export class JobFile extends JobBase {
        type:'file' = 'file'

        fileToSend:File = null;

        constructor(public realm:string, public time:number, public force:'update'|'insert', public resource:string, public file:string, public items:Array<JobFileItem>) {
            super(realm, time, force)
        }
    }

    export class JobWordPressItem extends JobItem {
    }

    export class JobWordPress extends JobBase {
        type:'wordpress' = 'wordpress'

        constructor(public realm:string, public time:number, update:boolean, public APIUrl:string, public items:Array<JobWordPressItem>) {
            super(realm, time, update ? 'update' : null)
        }
    }

    export class JobDHMItem extends JobItem {
    }

    export class JobDHM extends JobBase {
        type:'dhm' = 'dhm'

        constructor(public realm:string, public time:number, public force:'update'|'update-secondaries', public items:Array<JobDHMItem>) {
            super(realm, time, force)
        }
    }

    export class JobEPPOIItem extends JobItem {
        municipality?: string
        page?: number
    }

    export class JobEPPOI extends JobBase {
        type:'eppoi' = 'eppoi'

        constructor(public realm:string, public time:number, public force:'update', public items:Array<JobEPPOIItem>) {
            super(realm, time, force)
        }
    }

    export type JobType = 'entourance' | 'file' | 'wordpress' | 'dhm' | 'eppoi';

    export type Job = JobEntourance | JobFile | JobWordPress | JobDHM | JobEPPOI;

    export class TreeDirectoryDirectory { 
        id: string
        name: string
        contents: { 
            directories: number, 
            files: number
        } 
    }

    export class TreeDirectoryFile { 
        id: string
        resource: string
        name: string
        municipality?: string
    }

    export class TreeDirectory { 
        id:string = null;
        directories:Array<TreeDirectoryDirectory> = []
        files:Array<TreeDirectoryFile> = []
    }
    
    export class TreePagedDirectory {
        items: Array<TreeDirectoryDirectory|TreeDirectoryFile> = null;
        page: number = null;
        pageSize: number = null;
        lastPage: number = null;
        totalCount: number = null;
    }

    export class CheckImportedEntry {
        item: JobItem
        element: any
    }

    export class CheckResult {
        imported: Array<CheckImportedEntry> = []
        incomplete: boolean = false
    }
}